import { createAction, props } from '@ngrx/store';

import { WaterAuthority, WaterAuthorityUpsertRequest } from '../models/water-authorities.model';

// Load Water Authorities
export const loadWaterAuthoritiesRequest = createAction('[Water Authorities] Load Water Authorities request');

export const loadWaterAuthoritiesSuccess = createAction('[Water Authorities] Load Water Authorities success', props<{ waterAuthorities: WaterAuthority[] }>());

export const loadWaterAuthoritiesFailure = createAction('[Water Authorities] Load Water Authorities failure', props<{ error: string }>());

// Upsert Water Authority
export const upsertWaterAuthorityRequest = createAction(
  '[Water Authorities] Upsert Water Authority request',
  props<{ waterAuthority: WaterAuthorityUpsertRequest }>(),
);

export const upsertWaterAuthoritySuccess = createAction(
  '[Water Authorities] Upsert Water Authority success',
  props<{ waterAuthority: WaterAuthorityUpsertRequest }>(),
);

export const upsertWaterAuthorityFailure = createAction('[Water Authorities] Upsert Water Authority failure', props<{ error: string }>());

// Dialog Actions
export const openCreateWaterAuthorityDialog = createAction('[Water Authorities] Open Create Water Authority Dialog');

export const openEditWaterAuthorityDialog = createAction('[Water Authorities] Open Edit Water Authority Dialog', props<{ waterAuthority: WaterAuthority }>());
